import { Component, OnInit, forwardRef } from '@angular/core';
import {
  NavController,
  NavParams,
  LoadingController,
  ActionSheetController,
  AlertController,
  ModalController,
  IonicModule,
} from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ModalPessoaPage } from '../../modal-pessoa/modal-pessoa.page';
import { OracaoAdmAddPage } from '../oracao-adm-add/oracao-adm-add.page';
import { OracaoAdmFiltroPage } from '../oracao-adm-filtro/oracao-adm-filtro.page';
import { OracaoRespostaPage } from '../oracao-resposta/oracao-resposta.page';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { OracaoProvider } from 'src/app/services/oracao/oracao';
import { UserProvider } from 'src/app/services/user/user';
import { format } from 'date-fns';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { ImagePipe } from 'src/app/pipes/image/image';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { NomenclaturaService } from 'src/app/services/nomenclatura/nomenclatura';

@Component({
  selector: 'app-oracao-adm',
  templateUrl: './oracao-adm.page.html',
  styleUrls: ['./oracao-adm.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    ImagePipe,
    NomenclaturaPipe,
    SemRegistroComponent,
  ],
})
export class OracaoAdmPage implements OnInit {
  oracoes: any = [];
  filtro: any = {};
  pagination: any = { currentPage: 0, pageCount: 0 };
  cc: any = 0;
  nomenclaturaDesc: string = '';
  nomenclaturaTestemunho: string = '';
  tipo: string = '0';
  loader = this.loadingController.create({
    message: this.translate.instant('Carregando'),
  });
  filtroTela: any = {
    publico: true,
    privado: true,
    respondido: true,
    naoRespondido: true,
    liberado: true,
    naoLiberado: true,
    testemunho: true,
    oracao: true,
    dtInicial: format(new Date(), 'yyyy-MM-dd'),
    dtFinal: format(new Date(), 'yyyy-MM-dd'),
    ordenacao: '2',
  };
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public oracaoProvider: OracaoProvider,
    public actionSheetCtrl: ActionSheetController,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
    private nomenclatura: NomenclaturaService,
    public userProvider: UserProvider,
    private translate: TranslateService
  ) {
    this.nomenclatura
      .transform('oracao')
      .then((data) => (this.nomenclaturaDesc = data));
    this.nomenclatura
      .transform('testemunho')
      .then((data) => (this.nomenclaturaTestemunho = data));
    this.tipo = this.navParams.get('tipo');

    this.loadAdmOracoes(null);
  }

  ngOnInit() {}

  getNomenclatura(tipo: string) {
    return tipo == '2' ? 'testemunho' : 'oracao';
  }

  loadAdmOracoes(infiniteScroll: { target: { complete: () => void } } | null) {
    this.pagination.currentPage++;
    this.oracaoProvider
      .getAdmOracoes(this.pagination, this.filtro, this.tipo)
      .subscribe((res) => {
        this.oracoes = this.oracoes.concat(res.oracoes);
        this.pagination = res.pagination;
        if (infiniteScroll) infiniteScroll.target.complete();
      });
  }

  mudarPublico(oracao: { liberado: string; id: any }) {
    let publico;
    if (oracao.liberado == '1') {
      publico = false;
      oracao.liberado = '0';
    } else {
      publico = true;
      oracao.liberado = '1';
    }

    this.oracaoProvider.setPublico(oracao.id, publico).subscribe(() => {});
  }

  async excluirOracao(oracao: { id: any }) {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant('Atenção'),
      message:
        this.translate.instant('Deseja excluir a ') +
        this.nomenclaturaDesc +
        this.translate.instant(' selecionada?'),
      buttons: [
        {
          text: this.translate.instant('Cancelar'),
          role: 'cancel',
          handler: (data) => {},
        },
        {
          text: this.translate.instant('Excluir'),
          handler: (data) => {
            this.oracaoProvider.excluir(oracao.id).subscribe(() => {
              this.oracoes.splice(this.oracoes.indexOf(oracao), 1);
            });
          },
        },
      ],
    });

    alert.present();
  }

  async responder(oracao: { status: string }) {
    var data = { oracao: oracao };
    const modalPage = await this.modalCtrl.create({
      component: OracaoRespostaPage,
      componentProps: data,
    });
    modalPage.present();

    (await modalPage.onWillDismiss()).data;
    if (data) {
      oracao.status = '2';
      this.pagination = { currentPage: 0, pageCount: 0 };
      this.loadAdmOracoes(null);
    }
  }

  async filtroMensagem() {
    var data = { filtro: this.filtroTela };
    const modalPage = await this.modalCtrl.create({
      component: OracaoAdmFiltroPage,
      componentProps: data,
    });
    modalPage.present();

    const filtro = await modalPage.onWillDismiss();
    if (filtro.data) {
      this.filtro = filtro.data.filtro;
      this.filtroTela = filtro.data.filtroTela;
      this.oracoes = [];
      this.pagination = { currentPage: 0, pageCount: 0 };
      this.loadAdmOracoes(null);
    }
  }

  public async openModalPessoa(idPessoa: any) {
    var data = { idPessoa: idPessoa, meuCadastro: false };
    const modalPage = await this.modalCtrl.create({
      component: ModalPessoaPage,
      componentProps: data,
    });
    modalPage.present();
  }

  public async openNova(pedido: any) {
    var data = { pedido: pedido, tipo: this.tipo };
    const modalPage = await this.modalCtrl.create({
      component: OracaoAdmAddPage,
      componentProps: data,
    });
    modalPage.present();

    (await modalPage.onWillDismiss()).data;
    if (data) {
      this.pagination = { currentPage: 0, pageCount: 0 };
      this.oracoes = [];
      this.loadAdmOracoes(null);
    }
  }

  async opcoesAdm(oracao: { idPessoa: any }) {
    var text;
    if (this.tipo == '2') {
      text =
        this.translate.instant('Usar como base para criar ') +
        this.nomenclaturaTestemunho;
    } else if (this.tipo == '1') {
      text =
        this.translate.instant('Usar como base para criar ') +
        this.nomenclaturaDesc;
    } else {
      text =
        this.translate.instant('Usar como base para criar ') +
        this.nomenclaturaDesc +
        '/' +
        this.nomenclaturaTestemunho;
    }

    if (this.userProvider.hasPermissao('ORACAO_DADOS_CONTATO')) {
      let actionSheet = await this.actionSheetCtrl.create({
        header: this.translate.instant('Opções'),
        cssClass: 'my-custom-class',
        buttons: [
          {
            text: this.translate.instant('Abrir dados da pessoa'),
            handler: () => {
              this.openModalPessoa(oracao.idPessoa);
            },
          },
          {
            text: text,
            handler: () => {
              this.openNova(oracao);
            },
          },
          {
            text: this.translate.instant('Cancelar'),
            role: 'cancel',
            handler: () => {},
          },
        ],
      });

      actionSheet.present();
    } else {
      let actionSheet = await this.actionSheetCtrl.create({
        header: this.translate.instant('Opções'),
        buttons: [
          {
            text: text,
            handler: () => {
              this.openNova(oracao);
            },
          },
          {
            text: this.translate.instant('Cancelar'),
            role: 'cancel',
            handler: () => {},
          },
        ],
      });

      actionSheet.present();
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
